import API from "../../../../services/api.svelte.js";
import { notificate } from "../../../../services/notification.js";
import { locale, format } from 'svelte-i18n';
import { get as getStore } from 'svelte/store';

function setLocale() {
    let setLocale = getStore(locale);
    if (setLocale != "es" && setLocale != "en") setLocale = 'es';
    locale.set(setLocale);
}

// store Promise to avoid multiple simultaneous API calls
let logbooksPromise;
let logbooks = [];

export function search(config = {}) {
    logbooksPromise = API.search('v2/logbooks/', config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(response => {
            logbooks = response;
            return logbooks;
        })
        ;

    return logbooksPromise;
}

export function find(id, config = {}) {
    return API.find("v2/logbooks", id, config);
}

export function save(data, files = [], config = {}) {
    return API.save('v2/logbooks', data, files, config)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                // api validation errors

                let toastConfig = {
                    data: data.title,
                    id: data.id,
                    options: {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }

                }

                notificate('save_error', "toast", toastConfig);
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", { data: apiData.name });
            //returns saved element to update dataTables
            return apiData;
        })
        ;
}

export function deleteEntry(logbook_id, entry_id, config = {}) {
    setLocale();
    return API.del(`v2/logbooks/${logbook_id}/entries/${entry_id}`, config)
        .then(async (response) => {
            if (!response.ok) {
                let toastConfig = {
                    data: getStore(format)("asset.word"),
                    options: {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                // api validation errors
                notificate('delete_error', "toast", toastConfig);
                throw await response.json();
            }
            else {
                notificate('delete_ok', "toast", { is_massive: false, data: getStore(format)("notifications.element") });
                return true;
            }
        })
        ;
}

export function open(id, config = {}) {
    return API.save(`v2/logbooks/${id}/open`, {}, [], config, true)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                // api validation errors

                let toastConfig = {
                    data: data.title,
                    id: data.id,
                    options: {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }

                }

                notificate('save_error', "toast", toastConfig);
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", { data: apiData.name });
            return apiData;
        })
        ;
}

export function close(id, config = {}) {
    return API.save(`v2/logbooks/${id}/close`, {}, [], config, true)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                // api validation errors

                let toastConfig = {
                    data: data.title,
                    id: data.id,
                    options: {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }

                }

                notificate('save_error', "toast", toastConfig);
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", { data: apiData.name });
            return apiData;
        })
        ;
}

let entriesPromise;
let entries = [];

export function searchEntries(logbook_id, config = {}) {
    entriesPromise = API.search(`v2/logbooks/${logbook_id}/entries/`, config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(response => {
            entries = response;
            return entries;
        })
        ;

    return entriesPromise;
}

export function findEntry(logbook_id, entry_id, config = {}) {
    return API.find(`v2/logbooks/${logbook_id}/entries`, entry_id, config);
}
export function saveEntry(logbook_id, data, files = []) {
    // Si tiene ID, es una edición (PATCH) y según el curl va por JSON
    if (data.id) {
        const payload = {
            summary: data.logbook_entry_summary,
            date_time: data.logbook_entry_datetime
        };
        // Usamos API.save que envía JSON por defecto
        return API.save(`v2/logbooks/${logbook_id}/entries`, { ...payload, id: data.id })
            .then(async (response) => {
                if (!response.ok) throw await response.json();
                return response.json();
            });
    }

    // Si NO tiene ID, es creación (POST) y va por Multipart
    return API.saveMultipart(`v2/logbooks/${logbook_id}/entries`, data, files)
        .then(async (response) => {
            if (!response.ok) throw await response.json();
            return response.json();
        });
}
export function editEntry(logbook_id, entry_id, data) {
    const payload = {
        summary: data.summary,
        date_time: data.date_time
    };

    return API.save(`v2/logbooks/${logbook_id}/entries`, { ...payload, id: entry_id })
        .then(async (response) => {
            if (!response.ok) throw await response.json();
            return response.json();
        });
}


export function searchAttachments(logbook_id, entry_id, config = {}) {
    entriesPromise = API.search(`v2/logbooks/${logbook_id}/entries/${entry_id}/attachments`, config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(response => {
            entries = response;
            return entries;
        })
        ;

    return entriesPromise;
}

export function findAttachment(logbook_id, entry_id, attachment_id, config = {}) {
    return API.find(`v2/logbooks/${logbook_id}/entries/${entry_id}/attachments/${attachment_id}/`, entry_id, config);
}

export function saveAttachment(logbook_id, entry_id, files = []) {
    return API.saveMultipart(
        `v2/logbooks/${logbook_id}/entries/${entry_id}/attachments`,
        {},
        files,
        {},
        'attachments'
    ).then(async (response) => {
        if (!response.ok) throw await response.json();
        return response.json();
    });
}

export function deleteAttachment(logbook_id, entry_id, attachment_id, config = {}) {
    setLocale();
    return API.del(`v2/logbooks/${logbook_id}/entries/${entry_id}/attachments/${attachment_id}`, config)
        .then(async (response) => {
            if (!response.ok) {
                let toastConfig = {
                    data: getStore(format)("notifications.element"),
                    options: {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                // api validation errors
                notificate('delete_error', "toast", toastConfig);
                throw await response.json();
            }
            else {
                notificate('delete_ok', "toast", { is_massive: false, data: getStore(format)("notifications.element") });
                return true;
            }
        })
        ;
}


export async function downloadAttachment(logbook_id, entry_id, attachment_id) {
    return API.getFile('v2/logbooks/' + logbook_id + '/entries/' + entry_id + "/attachments/" + attachment_id);
}


export default {
    search,
    save,
    find,
    open,
    close,
    searchEntries,
    findEntry,
    saveEntry,
    editEntry,
    deleteEntry,
    searchAttachments,
    saveAttachment,
    deleteAttachment,
    downloadAttachment,
}



